namespace TabAurous.Inventory {
    export interface StockAllocationForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: StockAllocationItemsEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        Remark: Serenity.TextAreaEditor;
    }

    export class StockAllocationForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.StockAllocation';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!StockAllocationForm.init)  {
                StockAllocationForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.ImageUploadEditor;
                var w5 = StockAllocationItemsEditor;
                var w6 = s.TextAreaEditor;

                Q.initFormType(StockAllocationForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'ProductItemImage', w4,
                    'ItemDetails', w5,
                    'CompanyId', w3,
                    'FinancialYearId', w3,
                    'UserId', w3,
                    'Remark', w6
                ]);
            }
        }
    }
}
